(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oshan-subscription-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function initializeSubscriptionSelector(component) {
      if (component.dataset.initialized === 'true') return;
      var root = component.closest('.op');
      if (!root) return;

      component.dataset.initialized = 'true';
      var sellingPlan = component.querySelector('.op-selling-plan');
      var purchaseList = component.querySelector('[data-op-purchase-list]');
      var priceEl = root.querySelector('.op-price');
      var stickyPriceEl = root.querySelector('.op-sb-price');

      function updateDisplayedPrice(price) {
        if (priceEl) priceEl.textContent = price;
        if (stickyPriceEl) stickyPriceEl.textContent = price;
      }

      function bindPurchaseOptions() {
        purchaseList.querySelectorAll('input[type="radio"]').forEach(function (input) {
          input.addEventListener('change', function () {
            if (!input.checked) return;
            sellingPlan.value = input.value;
            updateDisplayedPrice(input.dataset.price);
          });
        });
      }

      function renderPurchaseOptions(variantId) {
        var template = component.querySelector('[data-op-purchase-template="' + variantId + '"]');
        if (!template) return;
        purchaseList.replaceChildren(template.content.cloneNode(true));
        sellingPlan.value = '';
        bindPurchaseOptions();
        var selected = purchaseList.querySelector('input:checked');
        if (selected) updateDisplayedPrice(selected.dataset.price);
      }

      bindPurchaseOptions();
      root.querySelectorAll('.op-variant input').forEach(function (input) {
        input.addEventListener('change', function () {
          renderPurchaseOptions(input.value);
        });
      });
    }

    function initializeAllSubscriptionSelectors(container) {
      container.querySelectorAll('[data-op-subscription-selector]').forEach(initializeSubscriptionSelector);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAllSubscriptionSelectors(document);
      });
    } else {
      initializeAllSubscriptionSelectors(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAllSubscriptionSelectors(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
